import { render } from "./RegistrationForm.vue?vue&type=template&id=ac75252a"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader-v3/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/marketing/components/RegistrationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac75252a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac75252a', __exports__)) {
    api.reload('ac75252a', __exports__)
  }
  
  module.hot.accept("./RegistrationForm.vue?vue&type=template&id=ac75252a", () => {
    api.rerender('ac75252a', render)
  })

}


export default __exports__